import { Modal } from '@mantine/core'

import DNButton from 'src/components/Buttons/Button/DNButton'

type Props = {
  employerName?: string | null
  opened: boolean
  loading?: boolean
  onClose: () => void
  onConfirm: () => void
}

/**
 * Confirms turning off Indeed Apply for an Indeed connection. Job Sync keeps
 * posting; only the apply method changes, and only for jobs posted or updated
 * after this point.
 */
const IndeedApplyOptOutModal = ({
  employerName,
  opened,
  loading,
  onClose,
  onConfirm,
}: Props) => (
  <Modal
    opened={opened}
    onClose={onClose}
    title="Opt out of Indeed Apply?"
    centered
    closeOnEscape
    closeOnClickOutside
    classNames={{ title: 'font-semibold' }}
  >
    <div className="flex flex-col gap-4">
      <div className="text-sm text-doubleNickel-gray-700">
        You are about to opt {employerName || 'this Indeed employer'} out of
        Indeed Apply. Applicants who apply directly through Indeed will no
        longer come directly to Double Nickel.
      </div>
      <div className="text-sm text-doubleNickel-gray-500">
        Your jobs will still be posted to Indeed through Job Sync. This applies
        to jobs posted or updated from now on; jobs already live on Indeed keep
        Indeed Apply until they are next updated.
      </div>
      <div className="mt-2 flex justify-end gap-2">
        <DNButton variant="outline" onClick={onClose} type="button">
          Cancel
        </DNButton>
        <DNButton variant="primary" onClick={onConfirm} loading={loading}>
          Opt out
        </DNButton>
      </div>
    </div>
  </Modal>
)

export default IndeedApplyOptOutModal
